var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('Title',{attrs:{"title":"社区人员风采"}}),_c('div',{staticClass:"layout-view withoutTitle"},[_c('PersonnelIntroduction',{attrs:{"person_data":_vm.person_data}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }